import React from "react";

// Reusable checkbox using the native `accent-color` CSS property to recolor
// the browser's own checkbox to the app's accent (#F90091) instead of the
// default blue — same approach already used ad hoc in UserMenu.jsx's team
// billing-access checkboxes, now centralized so every checkbox in the app
// looks consistent without re-deriving this each time. Stays a real native
// <input type="checkbox">: full keyboard/focus/screen-reader behavior for
// free, no hidden-input/custom-SVG plumbing required.
export function Checkbox({ size = 16, style, ...rest }) {
  return (
    <input
      type="checkbox"
      style={{
        width: size,
        height: size,
        margin: 0,
        accentColor: "#F90091",
        cursor: rest.disabled ? "default" : "pointer",
        ...style,
      }}
      {...rest}
    />
  );
}
